<template>
  <Fragment>
    <footer>
      <div class="footer">
      
        <div class="footer_hashtag">
          <a target="_blank" href="https://www.instagram.com/explore/tags/atuskate/">#ATUSKATE</a>
        </div>
        <div class="footer_social">
          <div class="footer_social_t">follow us</div>
          <ul>
            <li>
              <a target="_blank" href="https://www.instagram.com/atuskate"><i
                  class="atuicons atuicons-instagram"></i></a>
            </li>
            <li>
              <a target="_blank" href="https://www.instagram.com/atighteru/"><i
                  class="atuicons atuicons-instagramm"></i></a>
            </li>
          </ul>
        </div>
        <div class="footer_bottom">
          <div class="footer_copyright">
            <a class="footer_logo" href="#"></a>© 2015—{{
              new Date() | moment("YYYY")
            }}
            All Right Reserved
          </div>

          <ExternalLinks ulClass="footer_links"></ExternalLinks>
          <div class="footer_top">
            <a href="#">go to top<i class="atuicons atuicons-top"></i></a>
          </div>
        </div>
      </div>
    </footer>

    <QuizModal v-if="showQuiz"></QuizModal>
  </Fragment>
</template>


<script>
import ExternalLinks from "./ExternalLinks";
import QuizModal from "../../components/QuizModal.vue";
import { Fragment } from "vue-fragment";
export default {
  name: "Footer",
  components: { ExternalLinks, QuizModal, Fragment },

  computed: {
    showQuiz() {
      const profile = this.$store.getters.profile;
      if (!profile) {
        return false;
      }

      if(!profile.isPremiumMember) {
        return false;
      }

      return !profile.frequency || !profile.bodyType;
    },
  },
};
</script>